import axiosCall from "./axios_call";

export const signIn = async ({ email, password }) => {
  return axiosCall.post("/auth/login", { email, password });
};

export const _login_with_pin = async ({ accountId, pin }) => {
  return axiosCall.post("/auth/login-with-pin", { accountId, pin });
};

export const _send_password_reset_mail = async (data) => {
  return axiosCall.post("/auth/forgot-password", data);
};

export const _sign_user_up = (data) => {
  return axiosCall.post("/auth/register", data);
};

export const _google_auth = (data) => {
  return axiosCall.post("/auth/google/mobile", data);
};

export const _request_email_change = (data) => {
  return axiosCall.post("/users/me/request-email-change", data);
};

export const _verify_email_change = (data) => {
  return axiosCall.post("/users/me/verify-email-change", data);
};

export const _resend_email_change_code = () => {
  return axiosCall.post("/users/me/resend-email-change-code");
};

export const _reset_password_with_token = (data) => {
  return axiosCall.post("/auth/reset-password", data);
};

export const _reset_user_password = (id, data) => {
  return axiosCall.patch(`/auth/reset-password/${id}`, data);
};

const pay_checkout = async ({ data, token }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post("/transactions/initiate_payments", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.post("/transactions/initiate_payments", data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _verify_user_email_signup = async (e) => {
  return axiosCall.post("/auth/verify-email", e);
};

export const _resend_verification_code = async (data) => {
  return axiosCall.post("/auth/resend-verification-code", data);
};

export const _request_sms_verification = async () =>
  axiosCall.post("/auth/request-sms-verification");

export const _verify_bonus_code = async (code, phone) =>
  axiosCall.post("/auth/verify-code", { code, phone });

export const _verify_sms = async (code, phone) =>
  _verify_bonus_code(code, phone);

export const _verify_sms_magic_link = async (token) =>
  axiosCall.get(`/auth/verify-sms-link?token=${encodeURIComponent((token || "").trim())}`);

export const _generate_sms_magic_link = async (data = {}) => {
  const baseUrl =
    data.baseUrl || (typeof window !== "undefined" ? window.location.origin : "");
  return axiosCall.post("/auth/generate-sms-magic-link", { ...data, baseUrl });
};

export const _get_web_push_public_key = async () =>
  axiosCall.get("/notifications/web-push/public-key");

export const _get_web_push_status = async () =>
  axiosCall.get("/notifications/web-push/status");

export const _subscribe_web_push = async (subscription) =>
  axiosCall.post("/notifications/web-push/subscribe", subscription);

export const _unsubscribe_web_push = async (endpoint) =>
  axiosCall.delete("/notifications/web-push/subscribe", { data: { endpoint } });

const _get_profile = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  if (!token) return;
  return axiosCall.get(`/users/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_user_wallet = async () => {
  const jwt_token = localStorage.konnect_token;
  const appRole = "user";
  const token = jwt_token;
  return axiosCall.get(`/wallet/balance`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_wallet_balance = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/wallet/balance`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _get_profile_from_signin = async (e) => {
  const appRole = "user";
  return axiosCall.get(`/auth/profile?app=${appRole}`, {
    headers: { Authorization: `Bearer ${e}` },
  });
};

export const _get_faqs = async (page) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get(`/faqs?page=${page}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_business_support_team = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get(`/businesses/${businessId}/support-team`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_all_support_executives = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get(`/admin/staffs?role=SUPPORT_EXECUTIVE`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_all_faqs_admin = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get(`/faqs/admin/all`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _create_faq = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.post(`/faqs`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_faq = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.patch(`/faqs/${id}`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_faq = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.delete(`/faqs/${id}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _complete_user_kyc = async (data) => {
  // const jwt_token = localStorage.konnect_token;
  // const token = jwt_token
  // return axiosCall.post(`/admin/user/complete_basic_info`, e, { headers: { "Authorization": `Bearer ${token}` } });

  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch("/admin/user/complete_basic_info", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.patch("/admin/user/complete_basic_info", data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _save_user_bvn = async (e) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/user-profile/complete_kyc`, e, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const _get_all_referrals = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/referral/network?page=${page}&per_page=${page_size}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_referral_commission_history = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/referrals/commissions?page=${page}&per_page=${page_size}`,
    {
      headers: { Authorization: "Bearer " + token },
    },
  );
};

export const _get_all_transaction_data = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");
  const token = jwt_token;
  return axiosCall(`/transactions/user?page=${page}&per_page=${page_size}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_countdown_value = async (num_of_days = 10) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) {
    return;
  }
  const token = jwt_token;
  return axiosCall(
    `/user-login-validations/mobile-first-login-countdown?num_of_days=${num_of_days}`,
    {
      headers: { Authorization: "Bearer " + token },
    },
  );
};

export const _fetch_bonus_account_history = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/bonuses?page=${page}&per_page=${page_size}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_all_account_details = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");
  const token = jwt_token;
  return axiosCall(`/account/details?page=${page}&per_page=${page_size}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _confirm_user_transfer_pin = async (pin) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/validate-transaction-pin`,
      { pin },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/validate-transaction-pin`,
      { pin },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _get_user_wallet_history = async ({ page = 1, limit = 10 } = {}) => {
  const jwt_token = localStorage.konnect_token;
  const url = `/wallet/transactions?page=${encodeURIComponent(
    page,
  )}&limit=${encodeURIComponent(limit)}`;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(url, { headers: { Authorization: `Bearer ${token}` } });
  } else {
    return axiosCall(url);
  }
};

export const _get_biker_wallet_transactions = async ({ page = 1, limit = 10 } = {}) => {
  const jwt_token = localStorage.konnect_token;
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  const url = `/wallet/business/transactions?${params.toString()}`;
  return axiosCall(url, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

const _get_user_transaction_history = async ({
  page = 1,
  page_size = 20,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  const url = `orders/my-orders?page=${encodeURIComponent(
    page,
  )}&per_page=${encodeURIComponent(
    page_size,
  )}&account_type=wallet&is_resturant_history=true`;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(url, { headers: { Authorization: `Bearer ${token}` } });
  } else {
    return axiosCall(url);
  }
};

const _get_saved_address = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/delivery-addresses/user`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/delivery-addresses/user`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _add_delivery_address = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/delivery-addresses`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/delivery-addresses`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_delivery_date_by_payment_option = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");
  const token = jwt_token;
  return axiosCall(`/delivery-date/available_dates?payment_opt=${e}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _bank_verification = async ({ account_bank, account_number }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const data = {
    bankCode: account_bank,
    accountNumber: account_number,
  };
  return axiosCall.post(`/funding/verify-account`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _checkout_summary = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post("/transactions/checkout_summery", data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.post("/transactions/checkout_summery", data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};
export const _shop_discount = async ({ sub_amount }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      "/rate-settings/shop_discout",
      { sub_amount },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  } else {
    return axiosCall.post(
      "/rate-settings/shop_discout",
      { sub_amount },
      { headers: { Authorization: "Bearer" + "" } },
    );
  }
};

export const _change_order_status = async ({ id, status }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${id}/change_status`,
      { status },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/orders/${id}/change_status`,
      { status },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};
export const _order_status_change = async ({ id, status }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/calcel_order/${id}`,
      { status },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/orders/calcel_order/${id}`,
      { status },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _wallet_verification = async ({ ref }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/admin/user/ref_code/${ref}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/admin/user/ref_code/${ref}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _payout = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`funding/transfer/bank`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _payout_internal = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/transfer/konnect`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/transfer/konnect`, data, {
      headers: { Authorization: "Bearer " },
    });
  }
};

const _delivery_info = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/delivery-fees/shop_order`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/delivery-fees/shop_order`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _change_password = async ({
  current_password,
  new_password,
  confirm_new_password,
}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const response = axiosCall.patch(
    `/users/me/change-password`,
    {
      oldPassword: current_password,
      newPassword: new_password,
      confirmPassword: confirm_new_password,
    },
    { headers: { Authorization: "Bearer " + token } },
  );
  return response;
};

const _update_profile = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/users/me`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.patch(`/users/me`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _change_login_pin = async ({
  email,
  new_pin,
  confirm_new_pin,
  otpCode,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/set-login-pin`,
      { email, otpCode, newPin: new_pin, confirmPin: confirm_new_pin },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/set-login-pin`,
      { email, otpCode, newPin: new_pin, confirmPin: confirm_new_pin },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _update_2fa_verification = async ({ value }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/admin/user/change_login_2fa`,
      { status: value },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/admin/user/change_login_2fa`,
      { status: value },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _verify_2fa = async ({ otp }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/auth/confirm-otp-staus/${otp}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/auth/confirm-otp-staus/${otp}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _verify_pin = async ({ pin }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(
    `/auth/validate-transaction-pin`,
    { pin },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

const _update_trans_pin = async ({
  email,
  otpCode,
  new_pin,
  confirm_new_pin,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/auth/set-transaction-pin`,
      { email, otpCode, newPin: new_pin, confirmPin: confirm_new_pin },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/auth/set-transaction-pin`,
      { email, otpCode, newPin: new_pin, confirmPin: confirm_new_pin },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _calc_commission = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/rate-settings/transaction_fees`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  }
};

const _wise9ja_topup = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/transactions/initiate_payments`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/transactions/initiate_payments`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _rate_setting_by_id = async ({ id }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/rate-settings/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/rate-settings/${id}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _single_product = async ({ id }) => {
  return axiosCall(`/products/${id}`);
};

const _generate_otp = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/request-login-pin-otp`,
      {},
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/request-login-pin-otp`,
      {},
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

export const _request_transaction_pin_otp = async (email) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/request-transaction-pin-otp`,
      { email },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/request-transaction-pin-otp`,
      { email },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

export const _general_settings_by_id = async ({ id }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/general-settings/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/general-settings/${id}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_minimum_orders = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get(`/rates/minimum-orders`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _get_all_banks = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/funding/banks?country=NG`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_anchor_banks = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/funding/anchor/banks?country=NG`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_beneficiaries = async ({ type }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/beneficiaries?type=${type || ""}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _verify_otp = async ({ email, otpCode }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/validate-login-pin-otp`,
      { email, otpCode },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/validate-login-pin-otp`,
      { email, otpCode },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

export const _validate_transaction_pin_otp = async ({ email, otp }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/auth/validate-transaction-pin-otp`,
      { email, otpCode: otp },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.post(
      `/auth/validate-transaction-pin-otp`,
      { email, otp },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _get_all_state = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/locations/states`, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _get_all_cities = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/locations/states/lgas`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _restaurants_in_lga = async ({
  page,
  per_page,
  search,
  state,
  lga,
}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (per_page) params.append("limit", per_page);
  if (state) params.append("stateName", state);
  if (lga) params.append("lgaName", lga);

  return axiosCall(`/restaurant/public?${params.toString()}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _business_in_lga = async ({
  page,
  per_page,
  search,
  state,
  lga,
  type,
}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (per_page) {
    params.append("limit", per_page);
    params.append("per_page", per_page);
    params.append("pageSize", per_page);
  }
  if (state) params.append("stateName", state);
  if (lga) params.append("lgaName", lga);

  return axiosCall(`/${type}/public?${params.toString()}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_discovery_trending = async ({ state, lga }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/discovery/trending?state=${state}&lga=${lga}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_restaurant_order_metrics = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/businesses/me/metrics`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/businesses/me/metrics`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _single_restaurant = async ({ id }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/restaurant/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _single_business_data = async ({ id, type }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/${type}/business/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _single_business_menu = async ({
  businessId,
  type,
  page,
  per_page,
}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/menu/${businessId}/${type}?page=${page}&per_page=${per_page}`,
    {
      headers: { Authorization: "Bearer " + token },
    },
  );
};

export const _fetch_user_wallet_data = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get("/wallet/dashboard-stats", {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _user_dashboard_referrals = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get("/referrals/stats", {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _update_user_type = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.patch("/users/me/type", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _get_search_product = async ({ page, page_size, search }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/products?page=${page}&per_page=${page_size}&search=${search}`,
    {
      headers: { Authorization: "Bearer " + token },
    },
  );
};

export const _all_product = async ({ page, per_page, search }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/products/no_pagination?page=${page}&per_page=${per_page}&search=${search}`,
    {
      headers: { Authorization: "Bearer " + token },
    },
  );
};

const _get_all_pickup_locations = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/locations/no_pagination`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/locations/no_pagination`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _get_selected_delivery_location = async ({ id }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/delivery-addresses/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/delivery-addresses/${id}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _get_selected_pickup_location = async ({ id }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/locations/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/locations/${id}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _get_all_invoice = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/invoice/user?page=${page}&per_page=${page_size}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/invoice/user?page=${page}&per_page=${page_size}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_all_orders = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/orders/user?page=${page}&per_page=${page_size}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/orders/user?page=${page}&per_page=${page_size}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _complete_wise9ja_payment = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/wisenija-subs`, e, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/wisenija-subs`, e, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};
export const _fetch_wise9ja_plans = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/wisenija-subs/generate_sub_plan`, e, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/wisenija-subs/generate_sub_plan`, e, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_user_wise9ja_data = async ({ page_no, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(
      `/wisenija-subs/user?page=${page_no}&per_page=${page_size}`,
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall(
      `/wisenija-subs/user?page=${page_no}&per_page=${page_size}`,
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};
export const _fetch_user_sales_report = async ({
  page,
  page_size,
  search,
  from,
  to,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(
      `/sales-reps/sa/so_users?page=${page}&per_page=${page_size}&search=${search}&from=${from}&to=${to}`,
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall(
      `/sales-reps/sa/so_users?page=${page}&per_page=${page_size}&search=${search}&from=${from}&to=${to}`,
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

export const _fetch_user_sales_report_metric = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/sales-reps/user/metrix`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/sales-reps/user/metrix`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_referral_pool = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/users/me/referred`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/users/me/referred`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_wallet_data = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/wallet-history`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/wallet-history`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_user_wallet_balance = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/wallet/balance`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/wallet/balance`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_user_account_history = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  // return axiosCall(`/user-dashboard/loyalty_account`, {
  //   headers: { Authorization: "Bearer " + token },
  // });
};

export const _get_wallet_lookup_by_account_id = async (account_id) => {
  const jwt_token = localStorage.konnect_token;
  let token = "";
  if (jwt_token) {
    token = jwt_token;
  }
  return axiosCall.get(`/users/account/${account_id}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _fetch_user_dashboard_data = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/orders/my-orders`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/orders/my-orders`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_user_wisenija_history = async (e) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/user-dashboard/wisenija_history`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/user-dashboard/wisenija_history`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_bank_list = async (country) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/funding/banks?country=${country ?? "NG"}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _complete_bank_transfer = async (req) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`funding/transfer/bank`, req, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _complete_business_transfer = async (req) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`funding/transfer/business/bank`, req, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _complete_wallet_transfer = async (req) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/transfer/konnect`, req, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/transfer/konnect`, req, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _complete_business_wallet_transfer = async (req) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/transfer/business/konnect`, req, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/transfer/business/konnect`, req, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _verify_user_bank_account = async (bank_code, account_num) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const data = {
    bankCode: bank_code,
    accountNumber: account_num,
  };
  return axiosCall.post(`/funding/verify-account`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _fetch_user_beneficiary_list = async () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/beneficiaries`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _transfer_to_beneficiary = async (beneficiaryId, data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/beneficiaries/${beneficiaryId}/transfer`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _verify_user_from_ref_code = async (e) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  // return axiosCall(`/admin/user/ref_code/${e}`, { headers: { "Authorization": "Bearer " + token } })
  return axiosCall(`/wallet/verify_user_account/${e}`, {
    headers: { Authorization: "Bearer " + token },
  });
};
export const _fetch_amount_trans_fee = async (e) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/rate-settings/transaction_fees`, e, {
    headers: { Authorization: "Bearer " + token },
  });
};

const _fund_user_wallet = (req) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/transactions/found_wallet`, req, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/transactions/found_wallet`, req, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _complete_user_paybill = (action, req) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/bills/${action}`, req, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/bills/${action}`, req, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};
export const _fetch_user_data_options = (action) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/bills/products/${action}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/bills/products/${action}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_user_meter_data = (slug, action) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/bills/validate_customer/${slug}/${action}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/bills/validate_customer/${slug}/${action}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_bill_options = (req) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/bills/providers?category_slug=${req}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/bills/providers?category_slug=${req}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _fetch_user_referral_data = (page, per_page) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/referrals/network?page=${page}&per_page=${per_page}&category=all`,
    { headers: { Authorization: "Bearer " + token } },
  );
};

export const _fetch_user_referral_stat = () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/bonuses/referral-stats`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _fetch_user_referral_bonus_account = (page, per_page) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/bonuses?page=${page}&per_page=${per_page}&category=all`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _become_ra_update = async ({ status }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/admin/user/become_ra`,
      { status },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/admin/user/become_ra`,
      { status },
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

const _get_invoice = async ({ trxt_ref }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/invoice/transaction_ref/${trxt_ref}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/invoice/transaction_ref/${trxt_ref}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _get_all_dates = async ({ type }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    // /delivery-date/type/${type}
    return axiosCall(`/delivery-date/available_dates`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/delivery-date/available_dates`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _verify_transactions = async (tx_ref) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    // /delivery-date/type/${type}
    return axiosCall(`/transactions/verify_payment_callback/${tx_ref}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/transactions/verify_payment_callback/${tx_ref}`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

const _get_all_wise9ja = async () => {
  return axiosCall(`/wisenija_plan/user?page=1&per_page=20`);
};

export const _send_user_complaint = async (e) => {
  return axiosCall.post(`/contact/submit`, e);
};

const _get_bills = async ({ searchParams }) => {
  return axiosCall(`/bills/categories/search?search=${searchParams}`);
};

export const verify_user_email = async (token) => {
  return axiosCall(`/auth/${token}/confirm-email`);
};

export const _get_referral_stats = async (token) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/referrals/stats`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/referrals/stats`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _user_dashboard_shop = async (token) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/orders/user-dashboard/shop`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/orders/user-dashboard/shop`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _user_dashboard_wise9ja = async (token) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/user-dashboard/wisenija_history`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/user-dashboard/wisenija_history`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};
export const _get_cities_by_state_code = async (stateName = "") => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(`/locations/states/name/${stateName}/lgas`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_categories = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/menu-categories`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/menu-categories`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_extras = async ({ search, page, per_page }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(
      `/menu/extra?keyword=${search}&page=${page}&per_page=${per_page}`,
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall(
      `/menu/extra?keyword=${search}&page=${page}&per_page=${per_page}`,
      { headers: { Authorization: "Bearer " + "" } },
    );
  }
};

export const _request_update_email = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/users/me/change-email`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.patch(`/users/me/change-email`, data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _calculate_restaurant_order_price = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/orders/calculate-price`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};
export const _placeMenuOrder = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/orders`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};
export const _get_single_restaurant_order_details = async (id) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get(`/orders/${id}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_business_transactions = async ({
  page = 1,
  limit = 10,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  const url = `/wallet/business/transactions${params.toString() ? "?" + params.toString() : ""}`;
  return axiosCall(url, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_all_restaurant_orders = async ({
  deliveryType = "all",
  status = "all",
  page = 1,
  limit = 10,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = new URLSearchParams();
  if (deliveryType !== "all") params.append("deliveryType", deliveryType);
  if (status !== "all") params.append("status", status);
  params.append("page", page);
  params.append("limit", limit);
  const url = `/orders/my-orders${params.toString() ? "?" + params.toString() : ""}`;
  return axiosCall(url, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_all_restaurant_child_orders = async ({
  deliveryType = "all",
  status = "all",
  page = 1,
  limit = 10,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = new URLSearchParams();
  if (deliveryType !== "all") params.append("deliveryType", deliveryType);
  if (status !== "all") params.append("status", status);
  params.append("page", page);
  params.append("limit", limit);
  const url = `/orders/my-child-orders${params.toString() ? "?" + params.toString() : ""}`;
  return axiosCall(url, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_korapay_dynamic_account = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  // return axiosCall.post(`/funding/virtual-account/create`, data, {
  //   headers: { Authorization: "Bearer " + token },
  // });
  return axiosCall.post(`/funding/initiate-transfer`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _call_virtual_account_webhook = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/webhook/virtual-account`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/webhook/virtual-account`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _callKycWebhookSimulation = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/funding/webhook/simulate-kyc`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _initiate_tier1_funding = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/tier1/initiate`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/tier1/initiate`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _verify_tier1_funding = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/funding/tier1/verify`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/funding/tier1/verify`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _account_number_verification = async ({ account_number }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/wallet/verify_user_account/${account_number}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/wallet/verify_user_account/${account_number}`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _get_restaurant_order = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/menu`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/menu`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _accept_restaurant_order = async (
  id,
  restaurantAcceptedDelivery,
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${id}/accept`,
      { restaurantAcceptedDelivery },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }
};

export const _reject_restaurant_order = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${id}/status/REJECTED`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }
};

export const _ready_restaurant_order = async (id, bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${id}/ready-for-pickup`,
      bikerId ? { bikerId } : {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
  }
};

export const _get_vendor_restaurant = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/restaurant/me`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/restaurant/me`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _update_restaurant_profile = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.patch(`/restaurant/me`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _toggle_restaurant_status = async (isOpen) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const data = { isOpen };
  return axiosCall.patch(`restaurant/me/toggle`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_user_wallet_account = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/wallet/user_wallet`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/wallet/user_wallet`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _get_bonus_history = async ({ page, page_size }) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall(
    `/user-dashboard/bonus_account_history?page=${page}&per_page=${page_size}`,
    { headers: { Authorization: "Bearer " + token } },
  );
};

export const _update_menu_qty = async (id, qty) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/menu/update_qty/${id}`,
      { qty_available: qty },
      { headers: { Authorization: "Bearer " + token } },
    );
  } else {
    return axiosCall.patch(
      `/menu/update_qty/${id}`,
      { qty_available: qty },
      { headers: { Authorization: "Bearer " } },
    );
  }
};

export const _add_menu = async (restaurantId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/menu`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/menu`, data, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _get_menu = async ({ restaurantId }) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall(`/menu`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall(`/menu`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _delete_menu_ = async (menu_id) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.delete(`/menu/${menu_id}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _add_restaurant = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/restaurant`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/restaurant`, data, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _delete_cooking_area_image = async (restaurant_id, image_id) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.delete(`/restaurant/${restaurant_id}/image/${image_id}`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.delete(`/restaurant/${restaurant_id}/image/${image_id}`, {
      headers: { Authorization: "Bearer " },
    });
  }
};

export const _update_business = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/businesses/me`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.patch(`/businesses/me`, data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _get_available_features = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/features`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.get(`/features`, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _get_business_support_manager = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/businesses/me/support-manager`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.get(`/businesses/me/support-manager`, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _create_business = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/businesses`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } else {
    return axiosCall.post(`/businesses`, data, {
      headers: { Authorization: "Bearer" + "" },
    });
  }
};

export const _get_biker_by_account_id = async (accountId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/users/account/${accountId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _get_my_biker_details = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/bikers/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _update_biker_availability = async (isAvailable) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/bikers/me`,
      { isAvailable },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _update_my_biker_details = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/bikers/me`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _cancel_order_by_sm = async (orderId, reason) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${orderId}/cancel-by-sm`,
      { reason },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _report_restaurant_issue = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/orders/${orderId}/report-restaurant-issue`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _confirm_pickup = async (orderId, pickupCode) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${orderId}/confirm-pickup`,
      {
        reference: pickupCode,
        pickupCode: pickupCode
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _report_restaurant_not_responding = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(
      `/orders/${orderId}/report-restaurant-not-responding`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _get_all_orders_for_sm = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/orders`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _biker_pickup_order = async (
  deliveryId,
  pickupCode,
  trackerLink,
  eta,
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/delivery/biker/pickup/${deliveryId}`,
      { pickupCode, trackerLink, eta },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _biker_deliver_order = async (deliveryId, buyerCode) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/delivery/biker/deliver/${deliveryId}`,
      { buyerCode },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _biker_buyer_absent = async (
  deliveryId,
  snapshotOfTracker,
  snapshotOfCall,
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/delivery/biker/buyer-absent/${deliveryId}`,
      { snapshotOfTracker, snapshotOfCall },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _get_biker_my_orders = async (status) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/bikers/my-orders?status=${status}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _biker_arrived = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/delivery/biker/arrived/${deliveryId}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _biker_start_delivery = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/delivery/biker/start-delivery/${deliveryId}`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _upload_image = async (file) => {
  let formData;
  if (file instanceof FormData) {
    formData = file;
  } else {
    formData = new FormData();
    formData.append("image", file);
    formData.append("file", file);
  }

  const jwt_token = localStorage.konnect_token;
  const headers = jwt_token ? { Authorization: `Bearer ${jwt_token}` } : {};

  return axiosCall.post("/upload-image", formData, {
    headers: {
      ...headers,
    },
  });
};

export const _upload_any_file = async (file) => {
  let formData;
  if (file instanceof FormData) {
    formData = file;
  } else {
    formData = new FormData();
    formData.append("file", file);
    const type = file?.type?.startsWith("video/") ? "video" : file?.type?.startsWith("audio/") ? "audio" : file?.type === "application/pdf" ? "document" : "image";
    formData.append("type", type);
    formData.append("purpose", "ambassador-post-template");
  }

  const jwt_token = localStorage.konnect_token;
  const headers = jwt_token ? { Authorization: `Bearer ${jwt_token}` } : {};

  return axiosCall.post("/upload-any-file", formData, {
    headers: {
      ...headers,
    },
  });
};

export const _onboard_biker = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/delivery/biker/onboard`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _onboard_restaurant_biker = async (restaurantId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/restaurant/${restaurantId}/bikers`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _get_my_business_orders = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
  startDate = "",
  endDate = "",
  date = "",
  dashboardSection = "",
  dateFrom = "",
  dateTo = "",
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("limit", limit.toString());
    if (search) params.append("search", search);
    if (status) params.append("status", status);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (date) params.append("date", date);
    if (dashboardSection) params.append("dashboardSection", dashboardSection);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);

    return axiosCall.get(`/orders/child-orders?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _get_pending_orders = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/restaurant/me/pending-orders`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching pending orders:", error);
    throw error;
  }
};

export const _get_biker_dashboard_metrics = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/bikers/dashboard-metrics`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching biker dashboard metrics:", error);
    throw error;
  }
};

export const _get_biker_today_orders = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/bikers/today-orders`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching biker today orders:", error);
    throw error;
  }
};

export const _get_delivery_details = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/delivery/${deliveryId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching delivery details:", error);
    throw error;
  }
};

export const _reassign_biker = async (deliveryId, newBikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/support/delivery/${deliveryId}/reassign`,
      {
        newBikerId,
      },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error reassigning biker:", error);
    throw error;
  }
};

export const _get_available_bikers = async ({ page, pageSize, search }) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/support/available-bikers`,
      {
        params: { page, pageSize, search },
      },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error fetching available bikers:", error);
    throw error;
  }
};

export const _geocode_address = async (address) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/maps/geocode`,
      {
        params: { address },
      },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error geocoding address:", error);
    throw error;
  }
};

export const _get_customer_addresses = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/customer/addresses`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching customer addresses:", error);
    throw error;
  }
};

export const _create_customer_address = async (addressData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/customer/addresses`, addressData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error creating customer address:", error);
    throw error;
  }
};

export const _get_customer_address = async (addressId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/customer/addresses/${addressId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching customer address:", error);
    throw error;
  }
};

export const _update_customer_address = async (addressId, addressData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/customer/addresses/${addressId}`,
      addressData,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error updating customer address:", error);
    throw error;
  }
};

export const _delete_customer_address = async (addressId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(`/customer/addresses/${addressId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error deleting customer address:", error);
    throw error;
  }
};

export const _set_default_customer_address = async (addressId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(`/customer/addresses/${addressId}/default`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error setting default customer address:", error);
    throw error;
  }
};

export const _get_support_dashboard_metrics = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/dashboard-metrics`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support dashboard metrics:", error);
    throw error;
  }
};

export const _get_support_businesses = async (params = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.status) queryParams.append("status", params.status);
    if (params.lga) queryParams.append("lga", params.lga);
    if (params.serviceType)
      queryParams.append("serviceType", params.serviceType);

    const queryString = queryParams.toString();
    const url = queryString
      ? `/support/businesses?${queryString}`
      : `/support/businesses`;

    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support businesses:", error);
    throw error;
  }
};

export const _get_support_orders_new = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/orders`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support orders:", error);
    throw error;
  }
};

export const _get_delayed_deliveries = async ({
  page = 1,
  limit = 20,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/delayed-deliveries`, {
      params: { page, limit },
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching delayed deliveries:", error);
    throw error;
  }
};

export const _get_delivery_details_new = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/delivery/${deliveryId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching delivery details:", error);
    throw error;
  }
};

export const _reassign_delivery_biker = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/delivery/${deliveryId}/reassign-biker`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error reassigning delivery biker:", error);
    throw error;
  }
};

export const _cancel_delayed_delivery = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/delivery/${deliveryId}/cancel`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error cancelling delayed delivery:", error);
    throw error;
  }
};

export const _complete_intervention_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/complete`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error completing intervention order:", error);
    throw error;
  }
};

export const _accept_intervention_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/accept`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error accepting intervention order:", error);
    throw error;
  }
};

export const _assign_kd_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/assign-kd`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning KD order:", error);
    throw error;
  }
};

export const _reassign_kd_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/reassign-kd`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error reassigning KD order:", error);
    throw error;
  }
};

export const _get_intervention_available_bikers = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/support/intervention/order/${orderId}/available-bikers`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error fetching intervention available bikers:", error);
    throw error;
  }
};

export const _reject_intervention_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/reject`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error rejecting intervention order:", error);
    throw error;
  }
};

export const _ready_intervention_order = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/intervention/order/${orderId}/ready`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error marking intervention order as ready:", error);
    throw error;
  }
};

export const _contact_delivery_biker = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/delivery/${deliveryId}/contact-biker`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error contacting delivery biker:", error);
    throw error;
  }
};

export const _contact_delivery_customer = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/delivery/${deliveryId}/contact-customer`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error contacting delivery customer:", error);
    throw error;
  }
};

export const _escalate_delivery = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/delivery/${deliveryId}/escalate`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error escalating delivery:", error);
    throw error;
  }
};

export const _update_delivery_eta = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/support/delivery/${deliveryId}/update-eta`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error updating delivery ETA:", error);
    throw error;
  }
};

export const _get_delay_performance_analytics = async ({
  startDate,
  endDate,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    return await axiosCall.get(`/support/analytics/delay-performance`, {
      params,
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching delay performance analytics:", error);
    throw error;
  }
};

export const _get_support_orders = async (
  tab = "sales",
  page = 1,
  limit = 20,
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/support/orders?tab=${tab}&page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } else {
    return axiosCall.get(
      `/support/orders?tab=${tab}&page=${page}&limit=${limit}`,
    );
  }
};

export const _get_support_restaurants = async ({ service, page, limit }) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  const params = new URLSearchParams();
  if (service) params.append("service", service);
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());

  try {
    return await axiosCall.get(`/support/restaurants?${params.toString()}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support restaurants:", error);
    throw error;
  }
};

export const _get_support_order_details = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/orders/${orderId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support order details:", error);
    throw error;
  }
};

export const _cancel_support_order = async (orderId, reason) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/support/orders/${orderId}/cancel`,
      {
        reason,
      },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error cancelling support order:", error);
    throw error;
  }
};

export const _get_raw_food_profile = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/raw_food/me`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/raw_food/me`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_menus = async (businessId, businessType) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get(`/menu/${businessId}/${businessType}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_raw_food_menus = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get(`/menu/${businessId}/raw_food`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_store_menus = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get(`/menu/${businessId}/store`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _create_raw_food_business = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/raw_food`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/raw_food`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _update_raw_food_profile = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/raw_food/me`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.patch(`/raw_food/me`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _get_store_profile = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/store/me`, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.get(`/store/me`, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _create_store_business = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/store`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/store`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _update_store_profile = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.patch(`/store/me`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.patch(`/store/me`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _create_restaurant_menu = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/menu/restaurant`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.post(`/menu/restaurant`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _update_restaurant_menu = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.put(`/menu/restaurant/${id}`, data, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axiosCall.put(`/menu/restaurant/${id}`, data, {
      headers: { Authorization: "Bearer " + "" },
    });
  }
};

export const _create_menu = async (businessId, businessType, data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/menu/${businessId}/${businessType}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _create_menu_raw_food = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/menu/raw-food`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _create_menu_store = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/menu/store`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _create_menu_restaurant = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(`/menu/restaurant`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _update_menu = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.patch(`/menu/${id}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const _get_admin_businesses = async ({
  page,
  limit,
  search,
  status,
  lga,
  serviceType,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  const params = new URLSearchParams();
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (status) params.append("status", status);
  if (lga) params.append("lga", lga);
  if (serviceType) params.append("serviceType", serviceType);

  return axiosCall.get(`/support/businesses?${params.toString()}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_admin_available_businesses = async ({
  page,
  limit,
  search,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  const params = new URLSearchParams();
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (search) params.append("search", search);

  return axiosCall.get(`/admin/businesses/available?${params.toString()}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _approve_admin_business = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/businesses/${businessId}/status`,
    { status: "active" },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _reject_admin_business = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/businesses/${businessId}/status`,
    { status: "rejected" },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _update_admin_business_status = async (businessId, status) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/businesses/${businessId}/status`,
    { status },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _update_admin_business_special_status = async (
  businessId,
  isSpecial,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/businesses/${businessId}/special-status`,
    { isSpecial },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _get_admin_support_managers = async ({ page, limit, search }) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  const params = new URLSearchParams();
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (search) params.append("search", search);

  return axiosCall.get(`/admin/support-managers?${params.toString()}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _create_admin_support_manager = async (managerData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.post("/admin/support-managers", managerData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_admin_support_manager = async (managerId, managerData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(`/admin/support-managers/${managerId}`, managerData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_admin_support_manager = async (managerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.delete(`/admin/support-managers/${managerId}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _assign_businesses_to_manager = async (managerId, businessIds) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.post(
    `/admin/support-managers/${managerId}/assign-businesses`,
    { businessIds },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _bulk_assign_admin_businesses = async (assignments) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.post(
    "/admin/bulk-assign-businesses",
    { assignments },
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _get_admin_bikers = async ({
  page,
  limit,
  search,
  status,
  bikerType,
}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  const params = new URLSearchParams();
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (search) params.append("search", search);
  if (status) params.append("status", status);
  if (bikerType) params.append("bikerType", bikerType);

  return axiosCall.get(`/admin/bikers?${params.toString()}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _approve_admin_biker = async (bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/bikers/${bikerId}/approve`,
    {},
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _reject_admin_biker = async (bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Authentication required");

  return axiosCall.patch(
    `/admin/bikers/${bikerId}/reject`,
    {},
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _get_available_clusters = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("No authentication token");

  return axiosCall.get("/delivery/clusters/available", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _accept_delivery_cluster = async (clusterId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("No authentication token");

  return axiosCall.post(
    `/delivery/clusters/${clusterId}/accept`,
    {},
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _update_biker_vehicle_type = async (deliveryMode) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("No authentication token");

  return axiosCall.patch(
    `/bikers/me`,
    { deliveryMode },
    { headers: { Authorization: `Bearer ${jwt_token}` } },
  );
};

export const _get_restaurant_bikers_list = async (
  restaurantId,
  { page, pageSize, search },
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/restaurant/${restaurantId}/bikers`,
      {
        params: { page, pageSize, search },
      },
      { headers: { Authorization: `Bearer ${jwt_token}` } },
    );
  } catch (error) {
    console.error("Error fetching restaurant bikers:", error);
    throw error;
  }
};

export const _add_restaurant_biker = async (restaurantId, bikerData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/restaurant/${restaurantId}/bikers`,
      bikerData,
      { headers: { Authorization: `Bearer ${jwt_token}` } },
    );
  } catch (error) {
    console.error("Error adding restaurant biker:", error);
    throw error;
  }
};

export const _remove_restaurant_biker = async (restaurantId, bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(
      `/restaurant/${restaurantId}/bikers`,
      {
        data: { bikerId },
      },
      { headers: { Authorization: `Bearer ${jwt_token}` } },
    );
  } catch (error) {
    console.error("Error removing restaurant biker:", error);
    throw error;
  }
};

export const _get_restaurant_deliveries = async ({
  page,
  pageSize,
  date,
  dateFilter,
  pageFrom,
  pageTo,
  restaurantUserId,
}) => {
  const jwt = localStorage.konnect_token;
  if (!jwt) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/orders/business`,
      {
        params: {
          page,
          pageSize,
          date,
          pageFrom,
          pageTo,
          dateFilter,
          restaurantUserId,
        },
      },
      { headers: { Authorization: `Bearer ${jwt}` } },
    );
  } catch (error) {
    console.error(`Error fetching ${dateFilter} deliveries:`, error);
    throw error;
  }
};

export const _get_biker_profile = async (bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/delivery/biker/${bikerId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching biker profile:", error);
    throw error;
  }
};

export const _update_biker_profile = async (bikerId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(`/delivery/biker/${bikerId}`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating biker profile:", error);
    throw error;
  }
};

export const _deactivate_biker = async (bikerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/delivery/biker/${bikerId}/deactivate`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error deactivating biker:", error);
    throw error;
  }
};

export const _get_bill_providers = async (category = "") => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  const url = category
    ? `/bills/providers?category_slug=${category}`
    : "/bills/providers";
  return axiosCall.get(url, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_bill_plans = async (billerId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.get(`/bills/${billerId}/plans`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _validate_bill_payment = async (validationData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.post("/bills/validate-customer", validationData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _process_bill_payment = async (paymentData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.post("/bills/pay", paymentData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_bill_history = async ({ page = 1, limit = 20 } = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.get(`/bills/history?page=${page}&limit=${limit}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_user_accounts = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.get("/wallet/accounts", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _switch_active_account = async (accountId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.patch(
    `/wallet/accounts/${accountId}/activate`,
    {},
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _transfer_between_accounts = async (transferData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.post("/wallet/transfer-between-accounts", transferData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _initiate_tier_upgrade = async (upgradeData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.post("/tier/upgrade/initiate", upgradeData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _verify_tier_upgrade = async (verificationData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.post("/tier/upgrade/verify", verificationData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_user_tier_status = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.get("/user/tier-status", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_referral_dashboard = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  return axiosCall.get("/referrals/dashboard", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_referral_income_history = async (
  page = 1,
  limit = 20,
  type = "",
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);
  if (type) params.append("type", type);

  return axiosCall.get(`/referrals/income-history?${params.toString()}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _getBVNInstructions = () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get("/kyc/ussd-instructions", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _submitBVN = (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.post("/kyc/submit-bvn", data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _getBVNStatus = () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get("/kyc/bvn-status", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _getKycRequirements = () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get("/kyc/requirements", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _getTransferConfig = () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.get("/rates/transfer-config", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _calculateTransferFee = (feeData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  return axiosCall.post("/funding/calculate-fee", feeData, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _accept_delivery = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(
    `/delivery/biker/accept/${deliveryId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const _reject_delivery = async (deliveryId) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post(
    `/delivery/biker/reject/${deliveryId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const _validate_basket_stock = async (data) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.post("/orders/validate-basket-stock", data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_sla_not_accept = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/support/sla/not-accept?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } else {
    return axiosCall.get(`/support/sla/not-accept?page=${page}&limit=${limit}`);
  }
};

export const _get_sla_not_ready = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(`/support/sla/not-ready?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } else {
    return axiosCall.get(`/support/sla/not-ready?page=${page}&limit=${limit}`);
  }
};

export const _get_sla_not_picked = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/support/sla/not-picked?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } else {
    return axiosCall.get(`/support/sla/not-picked?page=${page}&limit=${limit}`);
  }
};

export const _get_sla_not_delivered = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/support/sla/not-delivered?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } else {
    return axiosCall.get(
      `/support/sla/not-delivered?page=${page}&limit=${limit}`,
    );
  }
};

export const _get_interventions_list = async (
  type,
  page = 1,
  limit = 20,
  supportManagerId = null,
  supportOfficerId = null,
) => {
  const jwt_token = localStorage.konnect_token;
  const params = new URLSearchParams();
  params.append("type", type);
  params.append("page", page.toString());
  params.append("limit", limit.toString());
  if (supportManagerId) params.append("supportManagerId", supportManagerId);
  if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);

  const queryString = params.toString();

  if (jwt_token) {
    return axiosCall.get(`/support/interventions/list?${queryString}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } else {
    return axiosCall.get(`/support/interventions/list?${queryString}`);
  }
};

export const _get_available_orders = async (page = 1, limit = 10) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(
      `/bikers/available-orders?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _accept_order = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(
      `/bikers/orders/${orderId}/accept`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  }
};

export const _get_my_orders = async (
  page = 1,
  limit = 10,
  status = "active",
  dateFrom = "",
  dateTo = "",
  search = "",
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    let url = `/bikers/my-orders?page=${page}&limit=${limit}&status=${status}`;
    if (dateFrom) url += `&dateFrom=${dateFrom}`;
    if (dateTo) url += `&dateTo=${dateTo}`;
    if (search) url += `&search=${search}`;
    return axiosCall.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _get_dashboard_metrics = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.get(`/bikers/dashboard-metrics`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
};

export const _report_buyer_absent_new = async (deliveryId, formData) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    const token = jwt_token;
    return axiosCall.post(`/delivery/buyer-absent/${deliveryId}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  }
};

export const _get_support_dashboard_home = () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get("/support/dashboard/home", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_new_support_orders = (
  tab = "sales",
  page = 1,
  limit = 20,
  supportManagerId,
  supportOfficerId,
  date,
) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  const params = { tab, page, limit };
  if (supportManagerId) params.supportManagerId = supportManagerId;
  if (supportOfficerId) params.supportOfficerId = supportOfficerId;
  if (date) params.date = date;
  return axiosCall.get("/support/orders", {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_support_interventions_dashboard = () => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get("/support/interventions/dashboard", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const _get_support_interventions_list = (
  type = "not-accept",
  page = 1,
  limit = 20,
) => {
  const jwt_token = localStorage.konnect_token;
  const token = jwt_token;
  return axiosCall.get("/support/interventions/list", {
    params: { type, page, limit },
    headers: { Authorization: `Bearer ${token}` },
  });
};

export {
  _add_delivery_address,
  _bank_verification,
  _calc_commission,
  _change_password,
  _delivery_info,
  _generate_otp,
  _get_all_banks,
  _get_all_cities,
  _get_all_dates,
  _get_all_invoice,
  _get_all_pickup_locations,
  _get_all_referrals,
  _get_all_state,
  _get_all_wise9ja,
  _get_bills,
  _get_invoice,
  _get_user_wallet_history,
  _get_user_transaction_history,
  _get_profile,
  _get_saved_address,
  _get_search_product,
  _get_selected_delivery_location,
  _get_selected_pickup_location,
  _payout,
  _rate_setting_by_id,
  _update_2fa_verification,
  _update_profile,
  _update_trans_pin,
  _verify_2fa,
  _verify_otp,
  _verify_transactions,
  _wallet_verification,
  _wise9ja_topup,
  pay_checkout,
  _fund_user_wallet,
  _confirm_user_transfer_pin,
  _change_login_pin,
};

export const _get_admin_dashboard_stats = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get("/admin/dashboard/stats", {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get("/admin/dashboard/stats");
};

export const _get_admin_interventions_count = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get("/admin/interventions/count", {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get("/admin/interventions/count");
};

export const _get_admin_users = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(`/admin/users?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/users?page=${page}&limit=${limit}`);
};

export const _verify_admin_user = async (userId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.put(
      `/admin/users/${userId}/verify`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  }
  return axiosCall.put(`/admin/users/${userId}/verify`, {});
};

export const _get_admin_transactions = async (
  page = 1,
  limit = 20,
  filters = {},
) => {
  const jwt_token = localStorage.konnect_token;
  const params = new URLSearchParams({ page, limit, ...filters });
  if (jwt_token) {
    return axiosCall.get(`/admin/transactions?${params.toString()}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/transactions?${params.toString()}`);
};

export const _get_admin_wallets = async (page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(`/admin/wallets?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/wallets?page=${page}&limit=${limit}`);
};

export const _get_admin_logs = async (page = 1, limit = 20, filters = {}) => {
  const jwt_token = localStorage.konnect_token;
  const params = new URLSearchParams({ page, limit, ...filters });
  if (jwt_token) {
    return axiosCall.get(`/admin/logs?${params.toString()}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/logs?${params.toString()}`);
};

export const _get_admin_orders_dashboard = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get("/admin/orders/dashboard", {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get("/admin/orders/dashboard");
};

export const _get_admin_orders = async (
  type = "todays",
  page = 1,
  limit = 20,
) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/admin/orders?type=${type}&page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  }
  return axiosCall.get(
    `/admin/orders?type=${type}&page=${page}&limit=${limit}`,
  );
};

export const _get_admin_interventions_dashboard = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get("/admin/interventions/dashboard", {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get("/admin/interventions/dashboard");
};

export const _get_admin_interventions = async (type, page = 1, limit = 20) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(
      `/admin/interventions?type=${type}&page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  }
  return axiosCall.get(
    `/admin/interventions?type=${type}&page=${page}&limit=${limit}`,
  );
};

export const _get_admin_order_detail = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(`/admin/orders/${orderId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/orders/${orderId}`);
};

export const _get_admin_intervention_detail = async (interventionId) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get(`/admin/interventions/${interventionId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get(`/admin/interventions/${interventionId}`);
};

export const _add_admin_business_service = async (businessId, serviceData) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.post(
      `/admin/businesses/${businessId}/services`,
      serviceData,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  }
  return axiosCall.post(
    `/admin/businesses/${businessId}/services`,
    serviceData,
  );
};

export const _get_admin_config_raw = async () => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.get("/admin/config/raw", {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.get("/admin/config/raw");
};

export const _update_admin_config_raw = async (configData) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.put("/admin/config/raw", configData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.put("/admin/config/raw", configData);
};

export const _delete_admin_config_raw = async (type) => {
  const jwt_token = localStorage.konnect_token;
  if (jwt_token) {
    return axiosCall.delete(`/admin/config/raw/${encodeURIComponent(type)}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  }
  return axiosCall.delete(`/admin/config/raw/${encodeURIComponent(type)}`);
};

export const _submit_buyer_help_request = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/orders/${orderId}/help-buyer`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error submitting buyer help request:", error);
    throw error;
  }
};

export const _submit_biker_help_request = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/orders/${orderId}/help-biker`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error submitting biker help request:", error);
    throw error;
  }
};

export const _process_intervention = async (orderId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/orders/${orderId}/process-intervention`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error processing intervention:", error);
    throw error;
  }
};

export const _send_biker_location_update = async (deliveryId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/deliveries/tracker/${deliveryId}/location`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error sending location update:", error);
    throw error;
  }
};

export const _get_notification_rules = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-rules`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching notification rules:", error);
    throw error;
  }
};

export const _get_notification_rule = async (eventType) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-rules/${eventType}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching notification rule:", error);
    throw error;
  }
};

export const _create_notification_rule = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/notification-rules`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error creating notification rule:", error);
    throw error;
  }
};

export const _update_notification_rule = async (eventType, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.put(`/notification-rules/${eventType}`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating notification rule:", error);
    throw error;
  }
};

export const _toggle_notification_rule = async (eventType, isActive) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/notification-rules/${eventType}/status`,
      { isActive },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error toggling notification rule:", error);
    throw error;
  }
};

export const _get_notification_preferences = async (userId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-preferences/${userId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching notification preferences:", error);
    throw error;
  }
};

export const _update_all_notification_preferences = async (userId, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.put(`/notification-preferences/${userId}`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating notification preferences:", error);
    throw error;
  }
};

export const _update_notification_preference = async (
  userId,
  channel,
  isOptedIn,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(
      `/notification-preferences/${userId}/${channel}`,
      { isOptedIn },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error updating notification preference:", error);
    throw error;
  }
};

export const _get_all_notification_templates = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-templates`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching all notification templates:", error);
    throw error;
  }
};

export const _get_notification_templates = async (eventType) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-templates/${eventType}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching notification templates:", error);
    throw error;
  }
};

export const _get_notification_template = async (eventType, channel) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(
      `/notification-templates/${eventType}/${channel}`,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error fetching notification template:", error);
    throw error;
  }
};

export const _update_notification_template = async (
  eventType,
  channel,
  data,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.put(
      `/notification-templates/${eventType}/${channel}`,
      data,
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error updating notification template:", error);
    throw error;
  }
};

export const _preview_notification_template = async (
  eventType,
  channel,
  variables,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/notification-templates/${eventType}/${channel}/preview`,
      { sampleData: variables },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error previewing notification template:", error);
    throw error;
  }
};

export const _get_notification_variables = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/notification-templates/variables`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching notification template variables:", error);
    throw error;
  }
};


export const _test_notification_email = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/admin/notifications/test/email`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error sending test email:", error);
    throw error;
  }
};

export const _test_notification_sms = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/admin/notifications/test/sms`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error sending test SMS:", error);
    throw error;
  }
};

export const _test_notification_push = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/admin/notifications/test/push`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error sending test push:", error);
    throw error;
  }
};

export const _test_notification_whatsapp = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/admin/notifications/test/whatsapp`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error sending test whatsapp:", error);
    throw error;
  }
};

export const _test_notification_all = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/admin/notifications/test/all`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error sending test all notifications:", error);
    throw error;
  }
};

export const _get_campaigns = async (params = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns`, {
      params,
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching campaigns:", error);
    throw error;
  }
};

export const _get_recipient_counts = async (params = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns/recipient-counts`, {
      params,
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching recipient counts:", error);
    throw error;
  }
};

export const _get_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns/${id}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching campaign:", error);
    throw error;
  }
};

export const _create_campaign = async (data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(`/campaigns`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error creating campaign:", error);
    throw error;
  }
};

export const _update_campaign = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.put(`/campaigns/${id}`, data, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating campaign:", error);
    throw error;
  }
};

export const _start_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/campaigns/${id}/start`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error starting campaign:", error);
    throw error;
  }
};

export const _pause_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/campaigns/${id}/pause`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error pausing campaign:", error);
    throw error;
  }
};

export const _resume_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/campaigns/${id}/resume`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error resuming campaign:", error);
    throw error;
  }
};

export const _get_campaign_stats = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns/${id}/stats`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching campaign stats:", error);
    throw error;
  }
};

export const _get_campaign_report = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns/${id}/report`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching campaign report:", error);
    throw error;
  }
};

export const _delete_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(`/campaigns/${id}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error deleting campaign:", error);
    throw error;
  }
};

export const _preview_campaign_template = async (id, sampleData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/campaigns/${id}/preview`,
      { sampleData },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error previewing campaign template:", error);
    throw error;
  }
};

export const _resend_campaign = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/campaigns/${id}/resend`,
      {},
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error resending campaign:", error);
    throw error;
  }
};

export const _get_campaign_logs = async (id) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/campaigns/${id}/logs`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching campaign logs:", error);
    throw error;
  }
};

export const _get_delivery_fee_stats = async () => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/businesses/me/delivery-fee-stats`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching delivery fee stats:", error);
    throw error;
  }
};

export const _get_support_officer_progress_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/progress?${queryString}`
      : `/support/dashboard/progress`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support officer progress dashboard:", error);
    throw error;
  }
};

export const _get_support_officer_sales_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales?${queryString}`
      : `/support/dashboard/sales`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support officer sales dashboard:", error);
    throw error;
  }
};

export const _get_support_officer_daily_breakdown = async (
  dateFrom,
  dateTo,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales/daily-breakdown?${queryString}`
      : `/support/dashboard/sales/daily-breakdown`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support officer daily breakdown:", error);
    throw error;
  }
};

export const _get_support_executive_home_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales?${queryString}`
      : `/support/dashboard/sales`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support executive home dashboard:", error);
    throw error;
  }
};

export const _get_support_executive_progress_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/progress?${queryString}`
      : `/support/dashboard/progress`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error(
      "Error fetching support executive progress dashboard:",
      error,
    );
    throw error;
  }
};

export const _get_support_staffs = async (params = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.search) queryParams.append("search", params.search);
    if (params.role) queryParams.append("role", params.role);

    const queryString = queryParams.toString();
    const url = queryString
      ? `/support/staff?${queryString}`
      : `/support/staff`;

    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support staffs:", error);
    throw error;
  }
};

export const _create_support_staff = async (staffData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post("/support/staff", staffData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error creating support staff:", error);
    throw error;
  }
};

export const _update_support_staff = async (staffId, staffData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.patch(`/support/staff/${staffId}`, staffData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating support staff:", error);
    throw error;
  }
};

export const _delete_support_staff = async (staffId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(`/support/staff/${staffId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error deleting support staff:", error);
    throw error;
  }
};

export const _assign_zone_to_staff = async (staffId, zoneId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/zones/${zoneId}/staff`,
      { staffIds: [staffId] },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning zone to staff:", error);
    throw error;
  }
};

export const _get_support_executive_intervention_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/interventions?${queryString}`
      : `/support/dashboard/interventions`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error(
      "Error fetching support executive intervention dashboard:",
      error,
    );
    throw error;
  }
};

export const _get_support_executive_sales_dashboard = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support-executives/dashboard/sales?${queryString}`
      : `/support-executives/dashboard/sales`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support executive sales dashboard:", error);
    throw error;
  }
};

export const _get_support_executive_support_managers = async ({
  page,
  limit,
  search,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (search) params.append("search", search);
    const queryString = params.toString();
    const url = queryString
      ? `/support-executives/support-managers?${queryString}`
      : `/support-executives/support-managers`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support managers for SE:", error);
    throw error;
  }
};

export const _get_support_executive_support_officers = async (
  supportManagerId,
  { page, limit, search } = {},
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (search) params.append("search", search);
    const queryString = params.toString();
    const url = queryString
      ? `/support-executives/support-managers/${supportManagerId}/support-officers?${queryString}`
      : `/support-executives/support-managers/${supportManagerId}/support-officers`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support officers for SE:", error);
    throw error;
  }
};

export const _get_admin_zones = async ({ page, limit, search } = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (search) params.append("search", search);
    const queryString = params.toString();
    const url = queryString
      ? `/support/zones?${queryString}`
      : `/support/zones`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching zones:", error);
    throw error;
  }
};

export const _get_admin_zone_detail = async (zoneId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/support/zones/${zoneId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching zone detail:", error);
    throw error;
  }
};

export const _create_admin_zone = async (zoneData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post("/support/zones", zoneData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error creating zone:", error);
    throw error;
  }
};

export const _update_admin_zone = async (zoneId, zoneData) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.put(`/support/zones/${zoneId}`, zoneData, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error updating zone:", error);
    throw error;
  }
};

export const _delete_admin_zone = async (zoneId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(`/support/zones/${zoneId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error deleting zone:", error);
    throw error;
  }
};

export const _assign_support_manager_to_zone = async (
  zoneId,
  supportManagerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const staffIds = Array.isArray(supportManagerId)
      ? supportManagerId
      : [supportManagerId];
    return await axiosCall.post(
      `/support/zones/${zoneId}/staff`,
      { staffIds },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning support manager to zone:", error);
    throw error;
  }
};

export const _assign_support_officers_to_zone = async (
  zoneId,
  supportOfficerIds,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/zones/${zoneId}/staff`,
      { staffIds: supportOfficerIds },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning support officers to zone:", error);
    throw error;
  }
};

export const _unassign_support_officer_from_zone = async (zoneId, soId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.delete(`/support/zones/${zoneId}/staff`, {
      data: { action: "unassign-officer", supportOfficerId: soId },
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error unassigning support officer from zone:", error);
    throw error;
  }
};

export const _assign_restaurants_to_support_officer = async (
  soId,
  restaurantIds,
  zoneId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/support-officers/${soId}/restaurants`,
      { action: "assign", zoneId, restaurantIds },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning restaurants to support officer:", error);
    throw error;
  }
};

export const _unassign_restaurant_from_support_officer = async (soId, rtId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      `/support/support-officers/${soId}/restaurants`,
      { action: "unassign", restaurantId: rtId },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error unassigning restaurant from support officer:", error);
    throw error;
  }
};

export const _get_admin_available_support_officers = async ({
  page,
  limit,
  search,
  zoneId,
} = {}) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (search) params.append("search", search);
    if (zoneId) params.append("zoneId", zoneId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/zones/available-officers?${queryString}`
      : `/support/zones/available-officers`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching available support officers:", error);
    throw error;
  }
};

export const _bulk_assign_business_to_officer = async (assignments) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      "/admin/businesses/assign-to-officer/bulk",
      { assignments },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error bulk assigning businesses to officers:", error);
    throw error;
  }
};

export const _assign_business_to_officer = async (
  businessId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.post(
      "/admin/businesses/assign-to-officer",
      { businessId, supportOfficerId },
      {
        headers: { Authorization: `Bearer ${jwt_token}` },
      },
    );
  } catch (error) {
    console.error("Error assigning business to officer:", error);
    throw error;
  }
};

export const _get_zone_restaurants = async (
  zoneId,
  { page, limit, search } = {},
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (page) params.append("page", page.toString());
    if (limit) params.append("limit", limit.toString());
    if (search) params.append("search", search);
    const queryString = params.toString();
    const url = queryString
      ? `/support/zones/${zoneId}/restaurants?${queryString}`
      : `/support/zones/${zoneId}/restaurants`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching zone restaurants:", error);
    throw error;
  }
};

export const _get_admin_sales_dashboard = async (
  zone,
  supportOfficerId,
  restaurantId,
  dateFrom,
  dateTo,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (zone) params.append("zone", zone);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    if (restaurantId) params.append("restaurantId", restaurantId);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    const queryString = params.toString();
    const url = queryString
      ? `/admin/dashboard/sales?${queryString}`
      : `/admin/dashboard/sales`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching admin sales dashboard:", error);
    throw error;
  }
};

export const _get_admin_sales_weekly_breakdown = async (
  zone,
  supportOfficerId,
  restaurantId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (zone) params.append("zone", zone);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    if (restaurantId) params.append("restaurantId", restaurantId);
    const queryString = params.toString();
    const url = queryString
      ? `/admin/dashboard/sales/weekly-breakdown?${queryString}`
      : `/admin/dashboard/sales/weekly-breakdown`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching admin sales weekly breakdown:", error);
    throw error;
  }
};

export const _get_admin_sales_daily_breakdown = async (
  zone,
  supportOfficerId,
  restaurantId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (zone) params.append("zone", zone);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    if (restaurantId) params.append("restaurantId", restaurantId);
    const queryString = params.toString();
    const url = queryString
      ? `/admin/dashboard/sales/daily-breakdown?${queryString}`
      : `/admin/dashboard/sales/daily-breakdown`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching admin sales daily breakdown:", error);
    throw error;
  }
};

export const _get_support_dashboard_sales = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales?${queryString}`
      : `/support/dashboard/sales`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support sales dashboard:", error);
    throw error;
  }
};

export const _get_support_sales_breakdown_weekly = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales/weekly-breakdown?${queryString}`
      : `/support/dashboard/sales/weekly-breakdown`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support sales weekly breakdown:", error);
    throw error;
  }
};

export const _get_support_sales_breakdown_daily = async (
  dateFrom,
  dateTo,
  supportManagerId,
  supportOfficerId,
) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const params = new URLSearchParams();
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (supportManagerId) params.append("supportManagerId", supportManagerId);
    if (supportOfficerId) params.append("supportOfficerId", supportOfficerId);
    const queryString = params.toString();
    const url = queryString
      ? `/support/dashboard/sales/daily-breakdown?${queryString}`
      : `/support/dashboard/sales/daily-breakdown`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching support sales daily breakdown:", error);
    throw error;
  }
};

export const _create_impersonation_session = async (businessId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(
    `/support-impersonation/sessions/${businessId}`,
    {},
    {
      headers: { Authorization: `Bearer ${jwt_token}` },
    },
  );
};

export const _end_impersonation_session = async (sessionId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/support-impersonation/sessions/${sessionId}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_active_impersonation_sessions = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/support-impersonation/sessions/active`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _apply_as_ambassador = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/apply`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_data = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/update-data`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_lesson_progress = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/lesson-progress`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _submit_ambassador_posts = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/submit-posts`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_ambassador_post = async (url) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/delete-post`, { url }, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_admin_ambassadors = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/admin/ambassadors`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _approve_ambassador = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassadors/${id}/approve`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _reject_ambassador = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassadors/${id}/reject`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _suspend_ambassador = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassadors/${id}/suspend`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _unsuspend_ambassador = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassadors/${id}/unsuspend`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_admin_ambassador_posts = async (status) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/admin/ambassador-posts${status ? `?status=${status}` : ''}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_post_status = async (id, status, adminNote) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/admin/ambassador-posts/${id}/status`, { status, adminNote }, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _apply_as_facilitator = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/apply-facilitator`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_status = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/status`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_schools = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/schools`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_schools = async (schoolsArray) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(
    `/ambassador/schools`,
    { schools: schoolsArray },
    { headers: { Authorization: `Bearer ${jwt_token}` } }
  );
};

export const _get_ambassador_dashboard = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/dashboard`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_agreement_pdf = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/agreement-pdf`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
    responseType: "blob",
  });
};

export const _get_ambassador_next_post = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/next-post`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_active_promo_assets = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/active-promo-assets`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_today_post_status = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/today-post-status`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_post_templates = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador/post-templates`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_fourward_account = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get('/fourward', { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_fourward_config = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get('/fourward/config', { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_fourward_quote = async (deposit) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post('/fourward/quote', { deposit }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _create_fourward_deposit = async (deposit) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post('/fourward/deposit', { deposit }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _transfer_fourward = async (recipientAccountNumber, amount) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post('/fourward/transfer', { recipientAccountNumber, amount }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_group_accounts = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get('/group-accounts', { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _create_group_account = async (name) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post('/group-accounts', { name }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _add_group_member = async (groupId, accountId, role) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/${groupId}/members`, { accountId, role }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _accept_group_account = async (groupId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/${groupId}/accept`, {}, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _reject_group_account = async (groupId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/${groupId}/reject`, {}, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _request_group_withdrawal = async (groupId, amount, destination) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/${groupId}/withdrawals`, { amount, destination }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _convert_group_wallet_to_fourward = async (groupId, amount) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/${groupId}/convert-wallet-to-fourward`, { amount }, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_group_account_history = async (groupId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/group-accounts/${groupId}/history`, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _approve_group_withdrawal = async (requestId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/group-accounts/withdrawals/${requestId}/approve`, {}, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_admin_ambassador_promos = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/admin/ambassador-promos`, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _create_admin_ambassador_promo = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassador-promos`, data, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _update_admin_ambassador_promo = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/admin/ambassador-promos/${id}`, data, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _delete_admin_ambassador_promo = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/admin/ambassador-promos/${id}`, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _get_admin_ambassador_promo_leaderboard = async (taskId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/admin/ambassador-promos/leaderboard${taskId ? `?taskId=${encodeURIComponent(taskId)}` : ""}`, { headers: { Authorization: `Bearer ${jwt_token}` } });
};

export const _upload_admin_ambassador_promo_flier = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/admin/ambassador-promos/upload-flier`, formData, {
    headers: { Authorization: `Bearer ${jwt_token}`, "Content-Type": "multipart/form-data" },
  });
};

export const _update_ambassador_next_post = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/next-post`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _set_active_ambassador_post_template = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador/post-templates/active/${id}`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_ambassador_post_template = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/ambassador/post-templates/${id}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_admin_reports = async (type, period = "") => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    const url = `/admin/reports/${type}${period ? `?period=${period}` : ""}`;
    return await axiosCall.get(url, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error(`Error fetching admin ${type} report:`, error);
    throw error;
  }
};

export const _lookup_admin_user = async (accountId) => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/admin/user-lookup/${accountId}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error looking up user by account ID:", error);
    throw error;
  }
};

export const _get_admin_balance_statement = async (accountType = "master", period = "this_month") => {
  const jwt_token = localStorage.konnect_token;
  if (!jwt_token) throw new Error("Unauthorized");
  try {
    return await axiosCall.get(`/admin/reports/balances/statement?accountType=${accountType}&period=${period}`, {
      headers: { Authorization: `Bearer ${jwt_token}` },
    });
  } catch (error) {
    console.error("Error fetching balance statement:", error);
    throw error;
  }
};

export const _get_category_presets = async (category = "") => {
  try {
    const url = `/menu/category-presets${category ? `?category=${category}` : ""}`;
    return await axiosCall.get(url);
  } catch (error) {
    console.error("Error fetching category presets:", error);
    throw error;
  }
};

export const _confirm_fc_items = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/orders/${orderId}/confirm-fc-items`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _confirm_special_pickup = async (orderId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/orders/${orderId}/confirm-special-pickup`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_active_fulfillment_centers = async () => {
  return axiosCall.get("/fulfillment-centers/active");
};

export const _get_admin_fulfillment_centers = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get("/admin/fulfillment-centers", {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _create_fulfillment_center = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post("/admin/fulfillment-centers", data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_fulfillment_center = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/admin/fulfillment-centers/${id}`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_fulfillment_center = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/admin/fulfillment-centers/${id}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _assign_restaurant_fulfillment_center = async (restaurantId, fcId) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/admin/restaurants/${restaurantId}/fulfillment-center`, { fulfillmentCenterId: fcId }, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};


export const _unhide_admin_config_raw = async (type) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/admin/config/raw/${type}/unhide`, {}, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_lessons = async () => {
  return axiosCall.get(`/ambassador-lessons`);
};

export const _get_all_ambassador_lessons_admin = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador-lessons/admin/all`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _create_ambassador_lesson = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador-lessons`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_lesson = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/ambassador-lessons/${id}`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_ambassador_lesson = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/ambassador-lessons/${id}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _get_ambassador_quiz_admin = async () => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.get(`/ambassador-lessons/quiz/admin/all`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _create_ambassador_quiz_question = async (data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.post(`/ambassador-lessons/quiz`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _update_ambassador_quiz_question = async (id, data) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.patch(`/ambassador-lessons/quiz/${id}`, data, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

export const _delete_ambassador_quiz_question = async (id) => {
  const jwt_token = localStorage.konnect_token;
  return axiosCall.delete(`/ambassador-lessons/quiz/${id}`, {
    headers: { Authorization: `Bearer ${jwt_token}` },
  });
};

